<template>
	<vx-card :title='$t("UserTypes")'>
		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="user_types">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addUserTypePrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ user_types.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : user_types.length }} of {{ user_types.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="name">{{$t("Name")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].name">
						{{ data[index].name }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addUserTypePrompt">
			<div>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="addName" style="width: 100%"></vs-input>

				<p class="mt-6">{{$t("MinimalWorkTimePerDay")}}</p>
				<vs-input type="number" v-model="addMinTime" style="width: 100%"/>

				<vs-checkbox class="mt-6" v-model="addIgnoreMultipliers" >{{$t("IgnoreMultipliers")}}</vs-checkbox>

				<vs-checkbox class="mt-6" v-model="addCarryTimeOver" >{{$t("CarryTimeOver")}}</vs-checkbox>
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addUserType">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>
	</vx-card>
</template>
<script>

	export default {
		data() {
			return {
				selected: {},
				user_types: [],

				itemsPerPage: 20,
				isMounted: false,

				addUserTypePrompt: false,

				addName: '',
				addMinTime: 0.0,
				addIgnoreMultipliers: false,
				addCarryTimeOver: true,

			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
		},
		methods: {
			handleSelected(tr) {
				this.$router.push({ name: 'userType', params: { id: tr.id } })
			},
			updateUserTypes() {
				const thisIns = this;
				this.$http.get('/api/v1/user_type/')
						.then(function (response) {
							thisIns.user_types = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addUserType() {
				const thisIns = this;
				this.$http.post('/api/v1/user_type/', {
					name: thisIns.addName,
					minimum_time_daily: Number(this.addMinTime),
					ignore_multipliers: this.addIgnoreMultipliers,
					carry_time_over: this.addCarryTimeOver,
				}).then(function () {
					thisIns.updateUserTypes();
					thisIns.addUserTypePrompt = false;
					thisIns.addName = "";
				}).catch(function (error) {
					thisIns.addUserTypePrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
		},
		watch: {
			editUserTypePrompt: function () {
				if(!this.editUserTypePrompt){
					this.selected = {}
				}
			}
		},
		created() {
			this.updateUserTypes()
		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addUserTypePrompt){
				this.addUserTypePrompt = false;
				next(false)
			}else if(this.editUserTypePrompt){
				this.editUserTypePrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
